import { Image, Modal, Text, Title, ActionButton } from "components/commons";
import React from "react";
import styles from "./success-modal.module.scss";
import locale from "localization";
import classNames from "classnames";
import { CarFormSuccess } from "images";

const SuccessModal = ({
  title,
  titleStyle,
  content = "",
  image = CarFormSuccess,
  primary,
  secondary,
  contentHighlight = [],
  contentStyle,
  centerButtons,
  loading,
  ...state
}) => {
  const {
    text: primaryText = "Got It",
    onClick: primaryOnClick = () => {
      state.close();
    },
  } = primary || {};

  const {
    text: secondaryText = "Cancel",
    onClick: secondaryClick = () => {
      state.close();
    },
  } = secondary || {};

  const shouldCenter = centerButtons !== undefined ? centerButtons : !secondary;

  return (
    <Modal {...state}>
      <div className={styles.container}>
        <Image src={image} className={styles.image} />
        <Title small className={classNames(styles.title, titleStyle)}>
          {title}
        </Title>
        <Text className={classNames(styles.content, contentStyle)}>
          <locale.Populate text={content} items={contentHighlight} />
        </Text>
      </div>
      <ActionButton
        center={shouldCenter}
        right={!shouldCenter}
        loading={loading ?? false}
        items={[
          ...(secondary
            ? [
                {
                  onClick: () => {
                    secondaryClick();
                    state.close();
                  },
                  text: secondaryText,
                  primary: false,
                  outline: secondary.outline,
                  style: secondary.style,
                },
              ]
            : []),
          {
            onClick: () => {
              primaryOnClick();
            },
            text: primaryText,
            primary: true,
          },
        ]}
      />
    </Modal>
  );
};

export default SuccessModal;
